import Request from '@/utils/request'

// 首充 活动
export function firstRechargeApi () {
  return Request({
    url: '/api/v2/app/shop/activity/7/cfg',
    method: 'get'
  })
}
